export default class TimePeriodController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.timePeriod = {
            id: Math.floor(Math.random() * 1000)
        };

        this.ruleTimePeriod = 'always';
        this.timePeriods = [];
        this.timePeriods.push(this.timePeriod);
    }

    addTimePeriod() {
        this.timePeriods.push(this.period);
    }

    isOptionTimePeriod() {
        return this.ruleTimePeriod === 'specific';
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/time-period/time-period.controller.js